// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MITs
import { gql } from 'apollo-angular';

export const projectVulnerabilityOverviewQuery = gql`
  query getProjectVulnerabilityOverview(
    $vulnerabilityOverviewInput: VulnerabilityOverviewInput!
  ) {
    projectVulnerabilityOverview(
      vulnerabilityOverviewInput: $vulnerabilityOverviewInput
    ) {
      lastScannedAt
      openIssues {
        high {
          fixableCount
          totalCount
        }
        medium {
          fixableCount
          totalCount
        }
        low {
          fixableCount
          totalCount
        }
        total {
          fixableCount
          totalCount
        }
      }
      overTimeIssues {
        label
        total
        fixable
        severity
        month
        quarter
        year
      }
    }
  }
`;
